module.exports = "/assets/images/cart-with-notify.svg";